import React from "react";
import { Redirect, Route, RouteProps, Switch, useLocation } from "react-router-dom";

interface IProps {
  routes: RouteProps[];
  redirectAllToPath?: string;
}

const RoutePropsSwitch: React.FC<IProps> = (props) => {
  const location = useLocation();

  return (
    <Switch>
      {props.routes.map((route, index) => (
        <Route {...route} key={index} />
      ))}
      {props.redirectAllToPath && (
        <Redirect
          from="*"
          push
          to={{
            pathname: props.redirectAllToPath,
            state: {
              from: `${location.pathname}${location.search}`,
            },
          }}
        />
      )}
    </Switch>
  );
};

export default RoutePropsSwitch;
